import React, { useEffect, useState } from "react";

import { List, ListItem, ListItemText, Paper, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import {
	loadFlashtalkingFtSegmentList,
	ftSegmentsToMap
} from "../flashtalkingSegments";

const InnovidSegments = () => {
	const [rawListCookie, setRawListCookie] = useState(null);
	const [segMapCookie, setSegMapCookie] = useState(null);

	const [rawListFTrack, setRawListFTrack] = useState(null);
	const [segMapFTrack, setSegMapFTrack] = useState(null);

	const [rawListHouseHold, setRawListHouseHold] = useState(null);
	const [segMapHouseHold, setSegMapHouseHold] = useState(null);

	const [error, setError] = useState(null);

	useEffect(function () {
		//cookies
		loadFlashtalkingFtSegmentList(
			"https://servedby.flashtalking.com/segment/read/;;javascript/",
			true
		)
			.then(function (list) {
				setRawListCookie(list);
				setSegMapCookie(ftSegmentsToMap(list));
				console.log("Cookie segments loaded:", list);
			})
			.catch(function (err) {
				setError(err.message);
			});

		//FTrack
		loadFlashtalkingFtSegmentList(
			"https://servedby.flashtalking.com/segment/read/;;javascript/?ft_pid=D9",
			true
		)
			.then(function (list) {
				setRawListFTrack(list);
				setSegMapFTrack(ftSegmentsToMap(list));
			})
			.catch(function (err) {
				setError(err.message);
			});
		//HouseHold
		loadFlashtalkingFtSegmentList(
			"https://servedby.flashtalking.com/segment/read/;;javascript/?ft_pid=HH",
			true
		)
			.then(function (list) {
				setRawListHouseHold(list);
				setSegMapHouseHold(ftSegmentsToMap(list));
			})
			.catch(function (err) {
				setError(err.message);
			});
	}, []);

	if (error) return <div>Segment error: {error}</div>;
	if (!rawListCookie) return <div>Loading segments…</div>;

	function updateSegment(key, value, type) {
		console.log("Updating segment:", key, "|", value);
		console.log(
			`https://servedby.flashtalking.com/segment/modify/;${value};javascript/${type}`
		);
		loadFlashtalkingFtSegmentList(
			`https://servedby.flashtalking.com/segment/modify/;${value};javascript/${type}`,
			false
		)
			.then(function () {
				//reload page
			})
			.catch(function (err) {
				setError(err.message);
			});
	}
	function clearAll() {
		let cookiecleared = false;
		let ftrackcleared = false;
		let hhcleared = false;
		let allcleared = false;
		let modiframe = document.getElementById("modIframe");
		let cookieEntries = Object.entries(segMapCookie);
		let idx = 0;
		let interval = setInterval(() => {
			if (idx < cookieEntries.length) {
				const [key, value] = cookieEntries[idx];
				modiframe.src = `https://servedby.flashtalking.com/segment/modify/;${value};javascript/`;
				idx++;
			} else {
				clearInterval(interval);
				cookiecleared = true;
			}
		}, 100);
		// FTrack
		// FTrack
		let ftrackEntries = Object.entries(segMapFTrack);
		let fIdx = 0;
		let fInterval = setInterval(() => {
			if (fIdx < ftrackEntries.length) {
				const [key, value] = ftrackEntries[fIdx];
				modiframe.src = `https://servedby.flashtalking.com/segment/modify/;${value};javascript/?ft_pid=d9`;
				fIdx++;
			} else {
				clearInterval(fInterval);
				ftrackcleared = true;
			}
		}, 100);

		// HouseHold
		let hhEntries = Object.entries(segMapHouseHold);
		let hhIdx = 0;
		let hhInterval = setInterval(() => {
			if (hhIdx < hhEntries.length) {
				const [key, value] = hhEntries[hhIdx];
				modiframe.src = `https://servedby.flashtalking.com/segment/modify/;${value};javascript/?ft_pid=hh`;
				hhIdx++;
			} else {
				clearInterval(hhInterval);
				hhcleared = true;
			}
		}, 100);
		// HouseHold
		Object.entries(segMapHouseHold).map(([key, value]) =>
			updateSegment(key, value, "?ft_pid=hh")
		);
		//reload the page
		setInterval(() => {
			if (cookiecleared && ftrackcleared && hhcleared) {
				window.location.reload();
			}
		}, 100);
	}
	return (
		<div>
			<Paper elevation={3} sx={{ mt: 2, p: 2 }}>
				<button
					onClick={clearAll}
					style={{
						backgroundColor: "red",
						color: "white",
						fontSize: "1.5rem",
						padding: "1rem 2rem",
						border: "none",
						borderRadius: "8px",
						cursor: "pointer",
						marginBottom: "24px",
						fontWeight: "bold"
					}}
				>
					Clear All
				</button>
				{!segMapCookie || Object.keys(segMapCookie).length === 0 ? (
					<Typography
						key={"cookie-segments-loaded1"}
						variant="h4"
						color="white"
						sx={{ mb: 2 }}
					>
						Cookie segments not loaded.
					</Typography>
				) : (
					<div>
						<Typography
							key={"cookie-segments-loaded2"}
							variant="h4"
							color="white"
							sx={{ mb: 2 }}
						>
							Cookie segments loaded.
						</Typography>
						<List
							key={"cookie-segments-loaded-list2"}
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								width: "50%",
								alignItems: "center",
								margin: "auto",
								marginBottom: "70px",
								minWidth: "350px"
							}}
						>
							{Object.entries(segMapCookie).map(([key, value]) => (
								<ListItem
									key={"cookie" + key}
									divider
									sx={{
										cursor: "pointer",
										transition: "background 0.2s",
										"&:hover": {
											backgroundColor: "#5a5a5aff"
										}
									}}
								>
									<ListItemText primary={value} secondary={key} />
									<IconButton
										key={key + "button"}
										edge="end"
										aria-label="delete"
										onClick={() => {
											updateSegment(key, value, "");
										}}
									>
										<DeleteIcon />
									</IconButton>
								</ListItem>
							))}
						</List>
					</div>
				)}
				{!segMapFTrack || Object.keys(segMapFTrack).length === 0 ? (
					<Typography
						key={"ftrack-segments-loaded1"}
						variant="h4"
						color="white"
						sx={{ mb: 2 }}
					>
						FTrack segments not loaded.
					</Typography>
				) : (
					<>
						<Typography
							key={"ftrack-segments-loaded2"}
							variant="h4"
							color="white"
							sx={{ mb: 2 }}
						>
							FTrack segments loaded.
						</Typography>
						<List
							key={"ftrack-segments-loaded-list"}
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								width: "50%",
								alignItems: "center",
								margin: "auto",
								marginBottom: "70px",
								minWidth: "350px"
							}}
						>
							{Object.entries(segMapFTrack).map(([key, value]) => (
								<ListItem
									key={"ftrack" + key}
									divider
									sx={{
										cursor: "pointer",
										transition: "background 0.2s",
										"&:hover": {
											backgroundColor: "#5a5a5aff"
										}
									}}
								>
									<ListItemText primary={value} secondary={key} />
									<IconButton
										key={key + "button"}
										edge="end"
										aria-label="delete"
										onClick={() => {
											updateSegment(key, value, "?ft_pid=d9");
										}}
									>
										<DeleteIcon />
									</IconButton>
								</ListItem>
							))}
						</List>
					</>
				)}
				{!segMapHouseHold || Object.keys(segMapHouseHold).length === 0 ? (
					<Typography
						key={"household-segments-loaded"}
						variant="h4"
						color="white"
					>
						HouseHold segments not loaded.
					</Typography>
				) : (
					<>
						<Typography
							key={"household-segments-loaded"}
							variant="h4"
							color="white"
							sx={{ mb: 2 }}
						>
							HouseHold segments loaded.
						</Typography>
						<List
							key={"HH-segments-loaded-list"}
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								width: "50%",
								alignItems: "center",
								margin: "auto",
								marginBottom: "70px",
								minWidth: "350px"
							}}
						>
							{Object.entries(segMapHouseHold).map(([key, value]) => (
								<ListItem
									key={"HH" + key}
									divider
									sx={{
										cursor: "pointer",
										transition: "background 0.2s",
										"&:hover": {
											backgroundColor: "#5a5a5aff"
										}
									}}
								>
									<ListItemText primary={value} secondary={key} />
									<IconButton
										key={key + "button"}
										edge="end"
										aria-label="delete"
										onClick={() => {
											updateSegment(key, value, "?ft_pid=HH ");
										}}
									>
										<DeleteIcon />
									</IconButton>
								</ListItem>
							))}
						</List>
					</>
				)}
			</Paper>
			<iframe id="modIframe" style={{ display: "block" }} />
		</div>
	);
};

export default InnovidSegments;
